/**
 * AXOIX API Configuration
 * Central configuration for all API endpoints
 */

// Environment-based API URLs
export const API_CONFIG = {
  // Main FastAPI backend. Fallback is production (not localhost) so a build missing the
  // env var still reaches the real API instead of silently POSTing signups to localhost.
  BASE_URL: process.env.REACT_APP_API_BASE_URL || "https://api.axoix.in",

  // RAG Service — proxied through main API, no direct IP exposure
  RAG_URL: `${process.env.REACT_APP_API_BASE_URL || "https://api.axoix.in"}/api/rag`,

  // Timeouts
  TIMEOUT: 30000, // 30 seconds (general)
  SIGNUP_TIMEOUT: 120000, // 2 minutes — provisioning creates DB, tables, seeds, email, PBX
  UPLOAD_TIMEOUT: 120000, // 2 minutes for file uploads
};

// API Endpoints
export const ENDPOINTS = {
  // Auth endpoints
  AUTH: {
    LOGIN: "/api/auth/login",
    REFRESH: "/api/auth/refresh",
    LOGOUT: "/api/auth/logout",
    PROFILE: "/api/auth/profile",
  },

  // Tenant/Signup endpoints
  TENANTS: {
    CHECK_SUBDOMAIN: "/api/tenants/check-subdomain",
    SIGNUP: "/api/tenants/signup",
    LIST: "/api/tenants",
    SEND_SIGNUP_OTP: "/api/tenants/send-signup-otp",
    VERIFY_SIGNUP_OTP: "/api/tenants/verify-signup-otp",
    REQUEST_RESUME: "/api/tenants/request-resume",
  },

  // Contact/Lead endpoints
  CONTACT: {
    SUBMIT: "/api/contact/submit",
    NEWSLETTER: "/api/contact/newsletter", // legacy alias, kept by mothership during transition
  },

  // Newsletter endpoints (double opt-in)
  NEWSLETTER: {
    SUBSCRIBE: "/api/newsletter/subscribe",
  },

  // AXOIX AI endpoints (HYPERION character)
  HYPERION: {
    CHAT: "/api/v1/hyperion/chat",
    VOICE: "/api/v1/hyperion/voice",
    COMMANDS: "/api/v1/hyperion/commands",
    WEBSOCKET: "/api/v1/hyperion/ws",
  },

  // RAG Service endpoints (separate URL)
  RAG: {
    HEALTH: "/health",
    QUERY: "/query",
    CATEGORIES: "/categories",
    STATS: "/stats",
  },

  // Projects
  PROJECTS: {
    LIST: "/api/projects",
    REGISTER: "/api/projects/register",
    DETAILS: "/api/projects", // /{id}
    ROTATE_KEY: "/api/projects", // /{id}/rotate-key
  },

  // Partner/Affiliate Program endpoints
  PARTNERS: {
    REGISTER: "/api/v1/partners/register",
    LOGIN: "/api/v1/partners/login",
    VALIDATE_CODE: "/api/v1/partners/validate", // /{referral_code}
  },

  // Billing/Payment endpoints (Razorpay)
  BILLING: {
    PRICING: "/api/billing/pricing",
    PAYMENT_MODE: "/api/billing/payment-mode",
    CREATE_ORDER: "/api/billing/create-order",
    VERIFY_PAYMENT: "/api/billing/verify-payment",
    CREATE_SUBSCRIPTION: "/api/billing/create-subscription",
    VERIFY_SUBSCRIPTION: "/api/billing/verify-subscription",
    CANCEL_SUBSCRIPTION: "/api/billing/cancel-subscription",
    SANDBOX_ACTIVATE: "/api/billing/sandbox-activate",
    SUBSCRIPTION: "/api/billing", // /{tenant_id}/subscription
    PAYMENTS: "/api/billing", // /{tenant_id}/payments
    WEBHOOK: "/api/billing/webhook",
  },
};

// Response status codes
export const STATUS_CODES = {
  SUCCESS: 200,
  CREATED: 201,
  BAD_REQUEST: 400,
  UNAUTHORIZED: 401,
  FORBIDDEN: 403,
  NOT_FOUND: 404,
  CONFLICT: 409,
  SERVER_ERROR: 500,
};
